export default __webpack_public_path__ + "media/zurb/img/growth-design/lead-gen-image-d43875483f3cbb68de43c652bbcf1ab7.png";